import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import moment from "moment";
import RepliProfilePregnancy from "./RepLIProfilePregnancy.component";
import RepLIProfileAdoption from "./RepLIProfileAdoption.component";
import RepLIProfileStepchildren from './RepLIProfileStepchildren.component';
import RepLIProfileChildrenDeath from './RepLIProfileChildrenDeath.component';
import RepLIProfileContraceptiveMethods from './RepLIProfileContraceptiveMethods.component';
import RepLIProfileFertilityPreservationMethods from './RepLIProfileFertilityPreservationMethods.component';
import RepLIProfileFertilityTreatments from './RepLIProfileFertilityTreatments.component';
import useStyles from './RepLIProfile.style';
import { races, sexualPreference } from "../../../data/db";
import { AppToggleButtonGroup, AppToggleButton } from '../../../pages/mobile/profiler/InputComponents';
import { Box } from '@material-ui/core';

const CustomTextField = props => {
    return <TextField
        variant="outlined"
        margin="normal"
        fullWidth
        InputProps={{ readOnly: true }}
        InputLabelProps={{ shrink: true }}
        {...props}
    />
};

const RepLIProfile = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const { profile } = props;

    return (
        <Grid container>
            <Grid item md={8} xs={12}>
                <form className={classes.form}>
                    <Grid container spacing={1}>
                        <Grid item xs={4}>
                            <CustomTextField
                                label={t('module.provider.addPatient.form.labels.email')}
                                value={profile.email}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label={t('module.provider.addPatient.form.labels.currentChildrenNum')}
                                value={profile.currentChildrenQty}
                                type="number"
                            />
                        </Grid>
                        {/* <Grid item xs={4}>
                                <CustomTextField
                                    label={t('module.provider.addPatient.form.labels.biologicalChildrenNum')}
                                    value={profile.biologicalChildren}
                                    type="number"
                                />
                            </Grid> */}
                        <Grid item xs={4}>
                            <CustomTextField
                                label={t('module.provider.addPatient.form.labels.desiredChildrenNum')}
                                value={profile.desiredChildrenQty}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label={t('module.provider.addPatient.form.labels.birthDate')}
                                type="date"
                                value={moment.utc(profile.dateOfBirth).format('YYYY-MM-DD')}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label={t('module.provider.addPatient.form.labels.firstMenstruationAge')}
                                type="number"
                                value={profile.firstPeriodAge}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label={t('module.provider.addPatient.form.labels.sexualDebutAge')}
                                type="number"
                                value={profile.sexuallyActiveAge}
                            />
                        </Grid>
                        {
                            profile.menopauseAge ?
                                <Grid item xs={4}>
                                    <CustomTextField
                                        label={t('module.provider.addPatient.form.labels.menopauseAge')}
                                        type="number"
                                        value={profile.menopauseAge}
                                    />
                                </Grid> :
                                <>

                                </>
                        }
                        <Grid item xs={8}>
                            <CustomTextField
                                label={t('module.provider.addPatient.form.labels.childbearingYearFrame')}
                                value={profile.childbearingYearFrame && `From ${profile.childbearingYearFrame[0]} to ${profile.childbearingYearFrame[1]}`}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel>
                                {t('module.provider.addPatient.form.labels.gender')}
                            </FormLabel>
                            <RadioGroup aria-label="Sexual Preference" value={profile.gender} row>
                                <FormControlLabel value="male" control={<Radio />} label={t('common.substantive.male')} />
                                <FormControlLabel value="female" control={<Radio />} label={t('common.substantive.female')} />
                                <FormControlLabel value="intersex" control={<Radio />} label={t('common.substantive.intersex')} />
                                <FormControlLabel value="preferNotToAnswer" control={<Radio />} label={t('common.substantive.PNA')} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel>
                                {t('module.provider.addPatient.form.labels.relationshipStatus')}
                            </FormLabel>
                            <RadioGroup aria-label="Relatioship Status" value={profile.relationshipStatus} row>
                                <FormControlLabel value="Single" control={<Radio />} label={t('common.adjective.single')} />
                                <FormControlLabel value="Dating" control={<Radio />} label={t('common.adjective.dating')} />
                                <FormControlLabel value="Living together" control={<Radio />} label={t('repliQuestionnaire.label.relationshipStatus.livingTogether')} />
                                <FormControlLabel value="Married" control={<Radio />} label={t('common.adjective.married')} />
                                <FormControlLabel value="Divorced / Separated" control={<Radio />} label={`${t('common.adjective.divorced')}/${t('common.adjective.separated')}`} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel>
                                {t('module.provider.addPatient.form.labels.genderIdentityStatus')}
                            </FormLabel>
                            <RadioGroup aria-label="Gender Identity" value={profile.genderIdentity} row>
                                <FormControlLabel value="Cisgender Female" control={<Radio />} label={t('common.genderIdentity.cisgenderFemale')} />
                                <FormControlLabel value="Cisgender Male" control={<Radio />} label={t('common.genderIdentity.cisgenderMale')} />
                                <FormControlLabel value="Transgender Female" control={<Radio />} label={t('common.genderIdentity.transgenderFemale')} />
                                <FormControlLabel value="Transgender Male" control={<Radio />} label={t('common.genderIdentity.transgenderMale')} />
                                <FormControlLabel value="Genderqueer or Gender Fluid" control={<Radio />} label={t('common.genderIdentity.genderqueer')} />
                                <FormControlLabel value="Questioning or unsure" control={<Radio />} label={t('common.genderIdentity.questioning')} />
                                <FormControlLabel value="Gender identity not listed" control={<Radio />} label={t('common.genderIdentity.GIL')} />
                                <FormControlLabel value="Prefer not to answer" control={<Radio />} label={t('common.genderIdentity.PNA')} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel>
                                {t('module.provider.addPatient.form.labels.raceEthnicity')}
                            </FormLabel>
                            <AppToggleButtonGroup aria-label="Race/Ethnicity" value={profile.races} row>
                                {races.map(race =>
                                    <AppToggleButton
                                        key={race}
                                        selected={profile.races.some(x => x === race)}
                                        name={race}
                                        label={race}
                                    />
                                )}
                            </AppToggleButtonGroup>
                        </FormControl>
                        <Box display={profile.races.some(x => x === 'Prefer to self-describe') ? 'block' : 'none'}>
                            <TextField
                                variant="outlined"
                                label="Self-describe"
                                margin="normal"
                                fullWidth
                                value={profile.raceSelfDescribe}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel>
                                {t('module.provider.addPatient.form.labels.sexualPreferences')}
                            </FormLabel>
                            <AppToggleButtonGroup aria-label="Sexual Orientation" value={profile.sexualPreferences} row>
                                {sexualPreference.map(preference =>
                                    <AppToggleButton
                                        key={preference}
                                        selected={profile.sexualPreferences.some(x => x === preference)}
                                        name={preference}
                                        label={preference}
                                    />
                                )}
                            </AppToggleButtonGroup>
                        </FormControl>
                        <Box display={profile.sexualPreferences.some(x => x === 'Prefer to self-describe') ? 'block' : 'none'}>
                            <TextField
                                variant="outlined"
                                label="Self-describe"
                                margin="normal"
                                fullWidth
                                value={profile.sexualPreferenceSelfDescribe}
                            />
                        </Box>
                    </Grid>
                </form>
            </Grid>
            <RepliProfilePregnancy profile={profile} />
            <RepLIProfileAdoption profile={profile} />
            <RepLIProfileStepchildren profile={profile} />
            <RepLIProfileChildrenDeath profile={profile} />
            <RepLIProfileContraceptiveMethods profile={profile} />
            <RepLIProfileFertilityPreservationMethods profile={profile} />
            <RepLIProfileFertilityTreatments profile={profile} />
            {/* <RepLIProfileCancerDiagnosisTreatments profile={profile} /> */}

        </Grid>
    );
};

export default RepLIProfile;